import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../og/Hero";
import { Marquee, CrossBands } from "../og/Marquee";
import { Products } from "../og/Products";
import { Collections } from "../og/Collections";
import { Lookbook } from "../og/Lookbook";
import { Manifesto } from "../og/Manifesto";
import { Newsletter } from "../og/Newsletter";
import { go } from "../og/Nav";
import { useLang } from "../og/i18n";

export default function Home({ ready }) {
  const { hash } = useLocation();
  const { t } = useLang();
  useEffect(() => {
    if (!hash) return undefined;
    const id = setTimeout(() => go(hash), 150);
    return () => clearTimeout(id);
  }, [hash]);

  return (
    <main data-testid="home-page">
      <Hero ready={ready} />
      <Marquee testid="welcome-marquee" items={["Welcome to Off Grid", "Welcome to Off Grid", "Welcome to Off Grid"]} variant="goth" speed={70} sep="✦" />
      <Products />
      <CrossBands
        a={["WELCOME TO OFF GRID", t("top.pre"), "WELCOME TO OFF GRID", t("top.ltd")]}
        b={["OFFLINE", "REAL TIME ONLY", "GOD'S PLAN IS GREATER", "WELCOME TO OFF GRID"]}
      />
      <Collections />
      <Lookbook />
      <Manifesto />
      <Newsletter />
    </main>
  );
}
